import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import { useWeights } from "../hooks/use-weights";

interface WeightInputProps {
    label: string;
    value: number | null;
    required?: boolean;
    onChange: (newGramsValue: number) => void;
}

export const WeightInput = (props: WeightInputProps) => {
    const { label, value, required, onChange } = props;

    const { convertFromGrams, convertToGrams, isDecimalWeight, weightAbbreviation } = useWeights();
    const [weightDisplay, setWeightDisplay] = React.useState(convertFromGrams(value || 0));
    return (
        <TextField
            type='number'
            variant='standard'
            fullWidth
            required={required}
            label={label}
            value={weightDisplay || ''}
            onChange={(e) => {
                const newWeight = Number(e.target.value);
                setWeightDisplay(newWeight);
                onChange(convertToGrams(newWeight));
            }}
            inputProps={{ min: 0, step: isDecimalWeight ? .01 : 1 }}
            InputProps={{
                endAdornment: <InputAdornment position='end'>{weightAbbreviation}</InputAdornment>
            }}
        />
    )
}